import { ISMT_ChuDe } from "../../model/respone/category/ISMT_ChuDe";
import { apiClient } from "../apiClient";
export const CHU_DE_ENDPOINT = "chu-de";
export const chuDeApi = {
  SelectAll: () => apiClient.get(`${CHU_DE_ENDPOINT}`),
  SelectVm: (id_nhomcauhoi: number) =>
    apiClient.get(`${CHU_DE_ENDPOINT}/select-vm/${id_nhomcauhoi}`),
  SelectByTypeAnswer: (payload: any) =>
    apiClient.post(`${CHU_DE_ENDPOINT}/select-by-type-answer`, payload),
  Insert: (payload: ISMT_ChuDe) =>
    apiClient.post(`${CHU_DE_ENDPOINT}`, payload),
  Update: (payload: ISMT_ChuDe) => apiClient.put(`${CHU_DE_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${CHU_DE_ENDPOINT}/${id}`),
  Import: (data: FormData) =>
    apiClient.upload(`${CHU_DE_ENDPOINT}/import`, data),
};
